import gridTemplateStyles from "../resources/gridTemplateStyles.json";

const GetRandomGridTemplate = (lastTemplateIndex) => {
  let possibleTemplateIndexes = [];

  //so templates dont repeat
  for (let i = 0; i < gridTemplateStyles.length; i++) {
    if (lastTemplateIndex !== i) {
      possibleTemplateIndexes.push(i);
    }
  }

  const randomIndex = Math.floor(
    Math.random() * possibleTemplateIndexes.length
  );

  return { index: randomIndex >= lastTemplateIndex ? (randomIndex + 1) : (randomIndex), template: gridTemplateStyles[randomIndex] };
};

export default GetRandomGridTemplate;
